import { gql } from '@apollo/client';

export const REEDEM_TALENT_INVITE_LINK = gql`
  mutation RedeemTalentInviteLink($input: RedeemTalentInviteLinkInput!) {
    redeemTalentInviteLink(input: $input) {
      id
      campaign {
        id
      }
    }
  }
`;
